import { call, put, takeLatest } from 'redux-saga/effects';
import request from '../../../api/request';
import requestAxios from '../../../api/requestAxios';

function* getAllTransfers(payload) {
  try {
    yield put({
      type: 'FETCH_WMS_TRANSFERS_REQUESTING',
    });

    yield put({
      type: 'SHOW_LOADING',
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/wms/transfers?page=${payload.value.page}&pageSize=${payload.value.pageSize}`;
    const headers = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    };
    const response = yield call(request, requestURL, headers);

    yield put({
      type: 'FETCH_WMS_TRANSFERS_SUCCESS',
      value: response,
    });

  } catch (error) {
    yield put({
      type: 'SHOW_ALERT',
      value: {
        type: 'danger',
        title: 'Error al cargar',
        message: 'Error al cargar los traslados',
      },
    });
    yield put({
      type: 'FETCH_WMS_TRANSFERS_ERROR',
    });
  } finally {
    yield put({
      type: 'HIDE_LOADING',
    });
  }
}

function* createTransfer(payload) {
  try {
    yield put({
      type: "CREATE_NEW_TRANSFER_REQUESTING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/wms/transfers`;

    const headers = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload.value),
    };

    const response = yield call(requestAxios, requestURL, headers);

    yield put({
      type: "CREATE_NEW_TRANSFER_SUCCESS",
      value: response,
    });

  } catch (error) {
    yield put({
      type: "CREATE_NEW_TRANSFER_ERROR",
      value: error.response,
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

function* getTransferForInboundByManifest(payload) {
  try {
    yield put({
      type: "FETCH_TRANSFER_FOR_INBOUND_BY_MANIFEST_REQUESTING",
    });
    yield put({
      type: "SHOW_LOADING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/wms/transfers/transfer-for-inbound/${payload.value.idManifest}`;

    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "FETCH_TRANSFER_FOR_INBOUND_BY_MANIFEST_SUCCESS",
      value: response.data,
    });
  } catch (error) {
    yield put({
      type: "FETCH_TRANSFER_FOR_INBOUND_BY_MANIFEST_ERROR",
      value: error.response,
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

function* processInboundTransfer(payload) {
  try {
    yield put({
      type: "PROCESS_TRANSFER_INBOUND_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/wms/transfers/process-inbound`;

    const headers = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload.value),
    };

    const response = yield call(requestAxios, requestURL, headers);

    yield put({
      type: "PROCESS_TRANSFER_INBOUND_SUCCESS",
      value: response,
    });

  } catch (error) {
    yield put({
      type: "PROCESS_TRANSFER_INBOUND_ERROR",
      value: error.response?.data || error,
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}


export function* watchTransfers() {
  yield takeLatest('FETCH_WMS_TRANSFERS_REQUEST', getAllTransfers);
  yield takeLatest('CREATE_NEW_TRANSFER_REQUEST', createTransfer);
  yield takeLatest("FETCH_TRANSFER_FOR_INBOUND_BY_MANIFEST_REQUEST", getTransferForInboundByManifest);
  yield takeLatest("PROCESS_TRANSFER_INBOUND_REQUEST", processInboundTransfer);
}
